import { css } from 'styled-components';
import { colors } from '../../../style-utilities/variables';
export default css``;
